import { useQuery } from "react-query";
import { getCustomerReceivedFileTypeDropdown } from "../api";

const useGetCustomerReceivedFileTypeDropdown = () => {
    return useQuery(['GetCustomerReceivedFileTypeDropdown'], getCustomerReceivedFileTypeDropdown, {
        refetchOnWindowFocus: false,
        onError: () => {
            // console.log('get all damage error')
        }
        ,
        onSuccess: (data) => {
           return data;
        }
       
    })
}
export {useGetCustomerReceivedFileTypeDropdown}